import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Container } from "react-bootstrap";

import "./styles.scss";
import { BANNER_TYPE } from "../../constants/notificationType";
import Button from "../Button";
import Info from "../Icon/Info";
import Success from "../Icon/Success";
import Alert from "../Icon/Alert";
import Warning from "../Icon/Warning";
import BannerClose from "../Icon/BannerClose";

const BANNER_ICON_COLOR = "#414042";

const BANNER_ICON = {
  [BANNER_TYPE.SUCCESS]: <Success className="banner-icon" />,
  [BANNER_TYPE.ALERT]: <Alert classNames="banner-icon" />,
  [BANNER_TYPE.INFO]: <Info className="banner-icon" />,
  [BANNER_TYPE.WARNING]: <Warning className="banner-icon" />,
};

const Banner = ({
  id,
  showIcon,
  closable,
  type,
  message,
  actions,
  onClose,
}) => (
  <Container fluid className={`banner-${type}`}>
    <Container className="banner px-4">
      <div className="content-section">
        {showIcon && BANNER_ICON[type]}
        <div className={classNames("banner-message", `banner-message-${type}`)}>
          {message}
        </div>
      </div>
      <div className="actions-section">
        {actions.map((buttonData, i) => (
          <Button
            key={i}
            className={classNames(
              "button",
              `button-${type}`,
              buttonData.className
            )}
            variant="link"
            onClick={buttonData.handleClick}
            href={buttonData.href}
            target={buttonData.target}
            disabled={buttonData.disabled}
          >
            {buttonData.text}
          </Button>
        ))}
        {closable && (
          <BannerClose
            onClick={() => onClose(id)}
            color={type !== BANNER_TYPE.ALERT ? BANNER_ICON_COLOR : "white"}
          />
        )}
      </div>
    </Container>
  </Container>
);

Banner.defaultProps = {
  type: BANNER_TYPE.INFO,
  showCloseButton: false,
  showIcon: false,
  firstButtonData: null,
  secondButtonData: null,
};

Banner.propTypes = {
  onClose: PropTypes.func,
  id: PropTypes.number.isRequired,
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(BANNER_TYPE)),
  closable: PropTypes.bool,
  showIcon: PropTypes.bool,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      handleClick: PropTypes.func,
      href: PropTypes.string,
      target: PropTypes.string,
      className: PropTypes.string,
      disabled: PropTypes.bool,
    }).isRequired
  ),
};

export default Banner;
